import { api } from '@/core/api/';
import utils from '@/utils/utilities';

export default {
  getReport(route, params) {
    return api.get(`/api/report/${route}`, {
      params: {
        ...params,
      },
    });
  },
  deleteReport(route, params) {
    return api.post(`/api/report/${route}`, {
      params: {
        ...params,
      },
    });
  },
  getBillingReport(route, billId) {
    return api.get(`/api/report/${route}/${billId}`);
  },
  getVisitCertificationDocuments(payload) {
    return api.post(`/api/report/visitcertifications`, payload);
  },
  getVisitCertification(payload) {
    return api.post(`/api/report/visitcertification`, payload);
  },
  getServiceCertificates(payload) {
    return api.post(`/api/report/servicecertificates/handwritten`, payload);
  },
  queueServiceCertificates(payload) {
    return api.post(`/api/report/servicecertificates/electronic`, payload);
  },
  generateServiceCertificates(visitSummaryId) {
    return api.post(
      `/api/digitalsignature/rp/servicecertificate/${visitSummaryId}`
    );
  },
  getConflictCorporationCertificate(adjustmentId) {
    return api
      .get(`/api/report/conflictCorporation/${adjustmentId}`)
      .then((response) => {
        utils.convertToBlob(response.data);
      });
  },
};
